import request from '@/utils/request'
const apiPath = '/sys/sysGoods'
const sysGoodsApi = {
  /**
   * 新增【系统商品】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【系统商品】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【系统商品】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【系统商品】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【系统商品】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【系统商品】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  getGoodRecomList(data) {
    return request.post(apiPath + '/getConfigList', data, { isFormData: 1 })
  },
  listPageForMini(query) {
    return request.get(`${apiPath}/tee/listPageForMini`, { params: query })
  }
}
export default sysGoodsApi
